import React from 'react';
import { motion } from 'framer-motion';
import { Flame, ThermometerSun, Snowflake, Wind, Wrench, Settings } from 'lucide-react';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function Services() {
  const services = [{
    title: 'Temporary Boilers',
    desc: 'High-efficiency packaged boilers engineered for maximum performance. Available in multiple fuel configurations.',
    icon: Flame,
    path: '/boiler-hire'
  }, {
    title: 'Portable Heaters',
    desc: 'Rapid deployment heating units suitable for industrial, commercial, and event applications.',
    icon: ThermometerSun,
    path: '/heater-hire'
  }, {
    title: 'Industrial Chillers',
    desc: 'Robust process and comfort cooling systems designed for critical temperature control.',
    icon: Snowflake,
    path: '/chiller-hire'
  }, {
    title: 'Cooling Systems',
    desc: 'Versatile air conditioning and evaporative cooling units for immediate temperature relief.',
    icon: Wind,
    path: '/cooling-hire'
  }, {
    title: 'Ancillary Equipment',
    desc: 'Comprehensive supporting infrastructure including heat exchangers, pumps, and distribution.',
    icon: Wrench,
    path: '/ancillaries'
  }];
  return <main className="flex-grow" data-id="element-464">
      <div className="bg-brand-navy py-24 relative overflow-hidden text-center" data-id="element-465">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }} data-id="element-466"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4" data-id="element-467">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-6xl font-heading font-extrabold text-white mb-6" data-id="element-468">
            Equipment <span className="text-brand-amber" data-id="element-469">Portfolio</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-470">
            Select a category below to explore our specialized fleet of
            temperature control assets.
          </motion.p>
        </div>
      </div>

      <section className="py-24 bg-brand-light" data-id="element-471">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-472">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-473">
            {services.map((svc, i) => <Link to={svc.path} key={i} data-id="element-474">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="bg-white p-10 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group h-full flex flex-col" data-id="element-475">
                  <div className="w-16 h-16 bg-brand-light rounded flex items-center justify-center mb-8 group-hover:bg-brand-amber transition-colors" data-id="element-476">
                    <svc.icon className="w-8 h-8 text-brand-navy group-hover:text-white transition-colors" data-id="element-477" />
                  </div>
                  <h3 className="text-2xl font-heading font-bold text-brand-navy mb-4" data-id="element-478">
                    {svc.title}
                  </h3>
                  <p className="text-brand-slate mb-8 flex-grow leading-relaxed" data-id="element-479">
                    {svc.desc}
                  </p>
                  <span className="text-brand-navy font-bold text-sm flex items-center uppercase tracking-wider group-hover:text-brand-amber transition-colors mt-auto" data-id="element-480">
                    View Specifications <span className="ml-2" data-id="element-481">→</span>
                  </span>
                </motion.div>
              </Link>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-482" />
    </main>;
}